export default __webpack_public_path__ + "static/media/Cartilha_Seguranca.731245aa.pdf";